/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEhrDocument } from './ExternalEhrDocument';
import {
    ExternalEhrDocumentFromJSON,
    ExternalEhrDocumentFromJSONTyped,
    ExternalEhrDocumentToJSON,
} from './ExternalEhrDocument';
import type { ScreenerGeneratedDocumentStatus } from './ScreenerGeneratedDocumentStatus';
import {
    ScreenerGeneratedDocumentStatusFromJSON,
    ScreenerGeneratedDocumentStatusFromJSONTyped,
    ScreenerGeneratedDocumentStatusToJSON,
} from './ScreenerGeneratedDocumentStatus';
import type { ScreenerGeneratedDocumentType } from './ScreenerGeneratedDocumentType';
import {
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeFromJSONTyped,
    ScreenerGeneratedDocumentTypeToJSON,
} from './ScreenerGeneratedDocumentType';

/**
 * 
 * @export
 * @interface ScreenerGeneratedDocument
 */
export interface ScreenerGeneratedDocument {
    /**
     * 
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    name?: string;
    /**
     * Null while the document is pending or generating asynchronously.
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    s3_key?: string;
    /**
     * Null while the document is pending or generating asynchronously.
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    instance_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerGeneratedDocument
     */
    previous_generated_at?: string;
    /**
     * 
     * @type {ScreenerGeneratedDocumentType}
     * @memberof ScreenerGeneratedDocument
     */
    type?: ScreenerGeneratedDocumentType;
    /**
     *
     * @type {ScreenerGeneratedDocumentStatus}
     * @memberof ScreenerGeneratedDocument
     */
    status?: ScreenerGeneratedDocumentStatus;
    /**
     * True when this document is stale enough that regenerating it would fetch fresh data instead of re-serving the cached copy.
     * @type {boolean}
     * @memberof ScreenerGeneratedDocument
     */
    can_regenerate?: boolean;
    /**
     * 
     * @type {ExternalEhrDocument}
     * @memberof ScreenerGeneratedDocument
     */
    external_ehr_document?: ExternalEhrDocument;
}

/**
 * Check if a given object implements the ScreenerGeneratedDocument interface.
 */
export function instanceOfScreenerGeneratedDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScreenerGeneratedDocumentFromJSON(json: any): ScreenerGeneratedDocument {
    return ScreenerGeneratedDocumentFromJSONTyped(json, false);
}

export function ScreenerGeneratedDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerGeneratedDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'generated_at': !exists(json, 'generated_at') ? undefined : json['generated_at'],
        'instance_id': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'previous_generated_at': !exists(json, 'previous_generated_at') ? undefined : json['previous_generated_at'],
        'type': !exists(json, 'type') ? undefined : ScreenerGeneratedDocumentTypeFromJSON(json['type']),
        'status': !exists(json, 'status') ? undefined : ScreenerGeneratedDocumentStatusFromJSON(json['status']),
        'can_regenerate': !exists(json, 'can_regenerate') ? undefined : json['can_regenerate'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : ExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function ScreenerGeneratedDocumentToJSON(value?: ScreenerGeneratedDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'generated_at': value.generated_at,
        'instance_id': value.instance_id,
        'previous_generated_at': value.previous_generated_at,
        'type': ScreenerGeneratedDocumentTypeToJSON(value.type),
        'status': ScreenerGeneratedDocumentStatusToJSON(value.status),
        'can_regenerate': value.can_regenerate,
        'external_ehr_document': ExternalEhrDocumentToJSON(value.external_ehr_document),
    };
}

